export default __webpack_public_path__ + "static/media/lions.98f72851.jpg";